import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { ToastController } from "ionic-angular";
import { AlertController, NavController, NavParams } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Status } from "../../models/interfaces/status.model";
import { MemberPage } from "../../pages/member/member";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-member_update",
  templateUrl: "member_update.html",
})
export class MemberUpdatePage {
  private status$;
  private shirtSize$;
  private memberForm: FormGroup;
  private member;
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, private db: DbserviceProvider,
              private camera: Camera, private alertCtrl: AlertController,
              private toastCtrl: ToastController,
  ) {
    console.log("MemberUpdatePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.member = this.navParams.get("member");
    this.memberForm = this.formBuilder.group({
      "mb_birthdate": ["", [Validators.required]],
      "mb_resignationdate": ["",],
      "mb_contact_mobile": ["", [Validators.required, ValidationserviceProvider.phoneValidator]],
      "mb_email_id": ["", [ValidationserviceProvider.emailValidator]],
      "mb_firstname": ["", [Validators.required]],
      "mb_formalname": [""],
      "mb_hashname": ["", [Validators.required]],
      "mb_id": [""],
      "mb_lastname": ["", [Validators.required]],
      "mb_notes": [""],
      "mb_photo": [""],
      "se_id": [""],
      "st_id": ["", [Validators.required]],
    });
  }

  private ionViewWillEnter() {
    console.log("MemberUpdatePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("MemberUpdatePage onInitPage");

    this.status$ = this.db.dbCol({
      "action": "select", "mapObject": "status",
      "sqlExtended": " order by st_order",
    });

    this.shirtSize$ = this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class='Member' order by se_order",
    });
    this.memberForm.controls.mb_id.setValue(this.member.mb_id);
    this.memberForm.controls.mb_hashname.setValue(this.member.mb_hashname);
    this.memberForm.controls.mb_firstname.setValue(this.member.mb_firstname);
    this.memberForm.controls.mb_lastname.setValue(this.member.mb_lastname);
    this.memberForm.controls.mb_formalname.setValue(this.member.mb_formalname);
    this.memberForm.controls.mb_notes.setValue(this.member.mb_notes);
    this.memberForm.controls.mb_email_id.setValue(this.member.mb_email_id);
    this.memberForm.controls.st_id.setValue(this.member.st_id);
    if ( this.member.mb_contact_mobile !== null ){
      this.memberForm.controls.mb_contact_mobile.setValue(this.member.mb_contact_mobile);
    }
    this.memberForm.controls.se_id.setValue(this.member.se_id);
    this.memberForm.controls.mb_birthdate.setValue(this.member.mb_birthdate);
    this.memberForm.controls.mb_resignationdate.setValue(this.member.mb_resignationdate);
    this.memberForm.controls.mb_photo.setValue(this.member.mb_photo);
  }

  private ngOnDestroy() {
    console.log("MemberUpdatePage ngOnDestroy");
    this.status$ = null;
  }

  private  DeletePicture() {
    console.log("MemberUpdatePage DeletePicture");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {}
        },
        "text", "No",
        {
          "handler": () => {
            alert("Photo deleted");
          },
          "text": "Yes",
        },
      ],
      "message": "Do you really want to delete the picture?",
      "title": "Delete Picture",
    });
    confirm.present();
  }


  private launchCamera() {
    console.log("MemberUpdatePage launchCamera");

  }

  private goback() {
    console.log("MemberUpdatePage goback");
    this.navCtrl.pop();
  }

  private updateMember(formValues: any) {
    console.log("MemberUpdatePage updateMember");
    this.db.dbCol({ "action": "update", "mapObject": "member", ...formValues }).subscribe(ret => {
      this.navCtrl.pop();
    });
  }

  private sendNotification(message: string): void {
    console.log("MemberUpdatePage sendNotification");
    let notification = this.toastCtrl.create({
      "duration": 3000,
      "message": message,
    });
    notification.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/member/member_update.ts